import { authRoles } from './auth/authRoles'
import navNewOrderIcon from 'assets/icons/nav/new_order.svg'
import navAllOrderIcon from 'assets/icons/nav/all_order.svg'
import navClientsIcon from 'assets/icons/nav/clients.svg'
import navPayIcon from 'assets/icons/nav/pay.svg'


// export const navigationsOld = [
//     {
//         name: 'Новый заказ',
//         path: '/order/newOrder',
//         icon: 'add_circle',
//         auth: authRoles.editor,
//         typeShow:["flower_shop"]
//     },
//     {
//         name: 'Новый заказ Тест',
//         path: '/order/newTest',
//         icon: 'add_circle',
//         auth: authRoles.editor,
//         typeShow:["fastfood"]
//     },
//     {
//         name: 'Новый заказ Фастфуд',
//         path: '/order/newOrderFastFood',
//         icon: 'add_circle',
//         auth: authRoles.editor,
//         accessPageName: 'NEWORDER',
//         typeShow:["fastfood"]
//     },
//     {
//         name: 'Быстрый заказ',
//         path: '/order/newOrderFast',
//         icon: 'local_mall',
//         auth: authRoles.editor,
//         typeShow:["flower_shop"]
//     },
//     {
//         name: 'Все заказы',
//         path: '/order/allOrder',
//         icon: 'line_weight',
//         auth: authRoles.editor,
//         typeShow:['flower_shop']
//     },
//     {
//         name: 'Все заказы Фастфуд',
//         path: '/order/allOrderFastFood',
//         icon: 'line_weight',
//         auth: authRoles.test,
//         accessPageName: 'ALLORDER',
//         typeShow:['fastfood']
//     },
//     {
//         name: 'Редактировать заказ',
//         path: '/order/editOrder',
//         icon: 'line_weight',
//         auth: authRoles.editor,
//         typeShow:["flower_shop"]
//     },
//     {
//         name: 'Склад',
//         path: '/catalog',
//         icon: 'storage',
//         auth: authRoles.editor,
//         accessPageName: 'CATALOG',
//         typeShow:["fastfood"]
//     },
//     {
//         name: 'Заказы с сайта',
//         path: '/dashboard/inventory-management',
//         icon: 'personal_video',
//         auth: authRoles.admin,
//         typeShow:["flower_shop"]
//     },
//     {
//         name: 'Клиентская база',
//         icon: 'person',
//         auth:authRoles.admin,
//         typeShow:["flower_shop"],
//         children: [
//             {
//                 name: 'Клиенты',
//                 path: '/klientList/KlientList',
//                 iconText: 'К',
//                 typeShow:["fastfood","flower_shop"]
//             },
//             {
//                 name: 'Получатели',
//                 path: '/klientList/recipietnList',
//                 iconText: 'П',
//                 typeShow:["flower_shop"]
//             },
//         ]
//     },
//     {
//         name: 'Клиенты',
//         icon: 'person',
//         path: '/klientList/KlientList',
//         iconText: 'К',
//         auth:authRoles.admin,
//         typeShow:["fastfood"]
//     }
//     ,
//     {
//         name: 'Аналитика',
//         path: '/dashboard/statsOrder',
//         icon: 'donut_large',
//         auth:authRoles.test,
//         accessPageName: 'ANALITIKA',
//         typeShow:["fastfood"]
//     },
//     {
//         name: 'Справочники',
//         icon: 'library_books',
//         auth:authRoles.test,
//         accessPageName: 'REFERENCE',
//         typeShow:["fastfood"],
//         children: [
//             {
//                 name: 'Типы платежей',
//                 path: '/reference/typePayments',
//                 icon: 'paid',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'TYPEPAYMENTS',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Сдача',
//                 path: '/reference/changeList',
//                 icon: 'paid',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'CHANGELIST',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Сотрудники',
//                 path: '/reference/employeesList',
//                 icon: 'engineering',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'EMPLOYEESLIST',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Статусы',
//                 path: '/reference/orderNotes',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'ORDERNOTES',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Пометки',
//                 path: '/reference/statusNotes',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'STATUSNOTES',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Каналы продаж',
//                 path: '/reference/orderSource',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'ORDERSOURCE',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Сертификаты',
//                 path: '/reference/Certificate',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'CERTIFICATE',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Списание',
//                 path: '/reference/writeOff',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'WRITEOFF',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Отметки',
//                 path: '/reference/Marks',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'MARKS',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Поставщики',
//                 path: '/reference/Suppliers',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'SUPPLIERS',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Единицы измерения',
//                 path: '/reference/Units',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'UNITS',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Улицы',
//                 path: '/reference/Street',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'STREET',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Наценки',
//                 path: '/reference/Markup',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'MARKUP',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Должности',
//                 path: '/reference/PositionWorker',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'POSITIONWORKER',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Скидки',
//                 path: '/reference/Discount',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'DISCOUNT',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Клиенты',
//                 path: '/reference/KlientDirectory',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.test,
//                 accessPageName: 'KLIENTS',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Организации',
//                 path: '/reference/Organization',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'ORGANIZATION',
//                 typeShow:["fastfood"]
//             },
//             {
//                 name: 'Промокоды',
//                 path: '/reference/Promocode',
//                 icon: 'checklist',
//                 iconText: '*',
//                 auth:authRoles.admin,
//                 accessPageName: 'PROMOCODE',
//                 typeShow:["fastfood"]
//             }]
//     },
//     {
//         name: 'Настройки',
//         icon: 'settings',
//         auth:authRoles.admin,
//         accessPageName: 'SETTINGS',
//         typeShow:["fastfood"],
//         children: [{
//             name: 'Филиалы',
//             path: '/Settings/AffiliateList',
//             icon: 'checklist',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'AFFILIATELIST',
//             typeShow:["fastfood"]
//         },
//         {
//             name: 'Точки Продаж',
//             path: '/Settings/Outlets',
//             icon: 'checklist',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'OUTLETS',
//             typeShow:["fastfood"]
//         },
//         {
//             name: 'Тестовый Новый товар',
//             path: '/NewProduct',
//             icon: 'checklist',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'NEWPRODUCT',
//             typeShow:["fastfood"]
//         }]
//     },
//     {
//         name: 'Маркетинг',
//         icon: 'settings',
//         auth:authRoles.admin,
//         accessPageName: 'MARKETING',
//         typeShow:["fastfood"],
//         children: [{
//             name: 'Нарушения',
//             path: '/marketing/Disturbance',
//             icon: 'checklist',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'DISTURBANCE',
//             typeShow:["fastfood"]
//         },
//         {
//             name: 'Настройки промокодов',
//             path: '/marketing/Promocode',
//             icon: 'checklist',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'PROMOCODESETTINGS',
//             typeShow:["fastfood"]
//         },
//         {
//             name: 'Создание промокодов визуал для К',
//             path: '/marketing/PromocodeCreate',
//             icon: 'checklist',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'PROMOCODECREATE',
//             typeShow:["fastfood"]
//         }
//         ]
//     },
//     {
//         name: 'Деньги',
//         icon: 'paid',
//         auth:authRoles.admin,
//         accessPageName: 'MONEY',
//         typeShow:["fastfood"],
//         children: [{
//             name: 'Касса',
//             path: '/money/cashbox',
//             icon: 'point_of_sale',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'CASHBOXX',
//             typeShow:["fastfood"]
//         },
//         ]
//     },
//     {
//         name: 'Доступы временно',
//         icon: 'paid',
//         auth:authRoles.admin,
//         accessPageName: 'ACCESSRIGHTS',
//         typeShow:["fastfood"],
//         children: [{
//             name: 'Настройки доступов',
//             path: '/AccessRightsSettings',
//             icon: 'point_of_sale',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'ACCESSRIGHTSSETTINGS',
//             typeShow:["fastfood"]
//         },
//         ]
//     },
//     {
//         name: 'Склад который списание и тд',
//         icon: 'shelves',
//         auth:authRoles.admin,
//         accessPageName: 'WAREHOUSE',
//         typeShow:["fastfood"],
//         children: [
//             {
//             name: 'Автосписание',
//             path: '/warehouse/SelfWriting',
//             icon: 'point_of_sale',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'SELFWRITING',
//             typeShow:["fastfood"]
//             },{
//             name: 'Списание',
//             path: '/warehouse/Writing',
//             icon: 'point_of_sale',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'WRITING',
//             typeShow:["fastfood"]
//             },{
//             name: 'Накладные',
//             path: '/warehouse/Consignment',
//             icon: 'point_of_sale',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'CONSIGNMENT',
//             typeShow:["fastfood"]
//             },{
//             name: 'Выпуск',
//             path: '/warehouse/Output',
//             icon: 'point_of_sale',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'OUTPUT',
//             typeShow:["fastfood"]
//             },{
//             name: 'Премещение',
//             path: '/warehouse/Moving',
//             icon: 'point_of_sale',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'MOVING',
//             typeShow:["fastfood"]
//             },{
//             name: 'Инвентаризация',
//             path: '/warehouse/Stocktaking',
//             icon: 'point_of_sale',
//             iconText: '*',
//             auth:authRoles.admin,
//             accessPageName: 'STOCKTAKING',
//             typeShow:["fastfood"]
//             },
//         ]
//     }
// ];


const SetNavTmp=()=>{
    const navigationsOld = [
        {
            name: 'Новый заказ',
            path: '/order/newOrder',
            iconSrc: navNewOrderIcon,
            icon: 'add_circle_outline',
            auth: authRoles.editor,
            typeShow:["flower_shop"]
        },
        {
            name: 'Новый заказ Тест',
            path: '/order/newTest',
            iconSrc: navNewOrderIcon,
            icon: 'add_circle_outline',
            auth: authRoles.editor,
            typeShow:["fastfood"]
        },
        {
            name: 'Новый заказ',
            path: '/order/newOrderFastFood',
            iconSrc: navNewOrderIcon,
            icon: 'add_circle_outline',
            auth: authRoles.editor,
            accessPageName: 'NEWORDER',
            typeShow:["fastfood"]
        },
        {
            name: 'Быстрый заказ',
            path: '/order/newOrderFast',
            icon: 'local_mall',
            auth: authRoles.editor,
            typeShow:["flower_shop"]
        },
        {
            name: 'Все заказы',
            path: '/order/allOrder',
            iconSrc: navAllOrderIcon,
            icon: 'layers',
            auth: authRoles.editor,
            typeShow:['flower_shop']
        },
        {
            name: 'Все заказы',
            path: '/order/allOrderFastFood',
            iconSrc: navAllOrderIcon,
            icon: 'layers',
            auth: authRoles.test,
            accessPageName: 'ALLORDER',
            typeShow:['fastfood']
        },
        {
            name: 'Редактировать заказ',
            path: '/order/editOrder',
            icon: 'edit',
            auth: authRoles.editor,
            typeShow:["flower_shop"]
        },
        {
            name: 'Товары',
            path: '/catalog',
            icon: 'storefront',
            moduleCode: 'catalog',
            auth: authRoles.editor,
            accessPageName: 'CATALOG',
            typeShow:["fastfood"]
        },
        {
            name: 'Заказы с сайта',
            path: '/dashboard/inventory-management',
            icon: 'language',
            auth: authRoles.admin,
            typeShow:["flower_shop"]
        },
        {
            name: 'Клиентская база',
            iconSrc: navClientsIcon,
            icon: 'person_outline',
            auth:authRoles.admin,
            typeShow:["flower_shop"],
            children: [
                {
                    name: 'Клиенты',
                    path: '/klientList/KlientList',
                    icon: 'people_outline',
                    iconText: 'К',
                    typeShow:["fastfood","flower_shop"]
                },
                {
                    name: 'Получатели',
                    path: '/klientList/recipietnList',
                    icon: 'person_pin',
                    iconText: 'П',
                    typeShow:["flower_shop"]
                },
            ]
        },
        {
            name: 'Клиенты',
            iconSrc: navClientsIcon,
            icon: 'person_outline',
            path: '/klientList/KlientList',
            iconText: 'К',
            auth:authRoles.admin,
            typeShow:["fastfood"]
        }
        ,
        {
            name: 'Выгрузка данных',
            path: '/data-export',
            icon: 'cloud_download',
            auth: authRoles.admin,
            accessPageName: 'SETTINGS',
            typeShow: ["fastfood"]
        },
        {
            name: 'Аналитика',
            icon: 'auto_graph',
            auth:authRoles.test,
            accessPageName: 'ANALITIKA',
            typeShow:["fastfood"],
            children: [
                {
                    name: 'Сводка',
                    path: '/dashboard/statsOrder',
                    icon: 'dashboard',
                    auth:authRoles.test,
                    accessPageName: 'ANALITIKA',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Тренд',
                    path: '/dashboard/trendOrder',
                    icon: 'insights',
                    auth:authRoles.test,
                    accessPageName: 'ANALITIKA',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Товары и меню',
                    path: '/dashboard/product-menu-analytics',
                    icon: 'restaurant_menu',
                    auth:authRoles.test,
                    accessPageName: 'ANALITIKA',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Когортный анализ',
                    path: '/dashboard/cohort-analytics',
                    icon: 'stacked_line_chart',
                    auth:authRoles.test,
                    accessPageName: 'ANALITIKA',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Время исполнения',
                    path: '/dashboard/execution-time',
                    icon: 'timer',
                    auth:authRoles.test,
                    accessPageName: 'ANALITIKA',
                    typeShow:["fastfood"]
                },
            ]
        },
        {
            name: 'Справочники',
            icon: 'menu_book',
            auth:authRoles.test,
            accessPageName: 'REFERENCE',
            typeShow:["fastfood"],
            children: [
                {
                    name: 'Типы платежей',
                    path: '/reference/typePayments',
                    icon: 'credit_card',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'TYPEPAYMENTS',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Сдача',
                    path: '/reference/changeList',
                    icon: 'currency_exchange',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'CHANGELIST',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Сотрудники',
                    path: '/reference/employeesList',
                    icon: 'badge',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'EMPLOYEESLIST',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Статусы',
                    path: '/reference/orderNotes',
                    icon: 'fact_check',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'ORDERNOTES',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Пометки',
                    path: '/reference/statusNotes',
                    icon: 'bookmark_border',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'STATUSNOTES',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Каналы продаж',
                    path: '/reference/orderSource',
                    icon: 'alt_route',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'ORDERSOURCE',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Сертификаты',
                    path: '/reference/Certificate',
                    icon: 'card_membership',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'CERTIFICATE',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Списание',
                    path: '/reference/writeOff',
                    icon: 'remove_circle_outline',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'WRITEOFF',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Отметки',
                    path: '/reference/Marks',
                    icon: 'flag',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'MARKS',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Поставщики',
                    path: '/reference/Suppliers',
                    icon: 'local_shipping',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'SUPPLIERS',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Единицы измерения',
                    path: '/reference/Units',
                    icon: 'straighten',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'UNITS',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Улицы',
                    path: '/reference/Street',
                    icon: 'signpost',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'STREET',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Наценки',
                    path: '/reference/Markup',
                    icon: 'trending_up',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'MARKUP',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Должности',
                    path: '/reference/PositionWorker',
                    icon: 'work_outline',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'POSITIONWORKER',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Скидки',
                    path: '/reference/Discount',
                    icon: 'percent',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'DISCOUNT',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Клиенты',
                    path: '/reference/KlientDirectory',
                    icon: 'groups',
                    iconText: '*',
                    auth:authRoles.test,
                    accessPageName: 'KLIENTS',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Организации',
                    path: '/reference/Organization',
                    icon: 'business',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'ORGANIZATION',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Промокоды',
                    path: '/reference/Promocode',
                    icon: 'sell',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'PROMOCODE',
                    typeShow:["fastfood"]
                }]
        },
        {
            name: 'Настройки',
            icon: 'tune',
            auth:authRoles.admin,
            accessPageName: 'SETTINGS',
            typeShow:["fastfood"],
            children: [{
                name: 'Общие',
                path: '/Settings/General',
                icon: 'settings',
                iconText: '*',
                auth:authRoles.admin,
                accessPageName: 'SETTINGS',
                typeShow:["fastfood"]
            },
            {
                name: 'Филиалы',
                path: '/Settings/AffiliateList',
                icon: 'account_tree',
                iconText: '*',
                auth:authRoles.admin,
                accessPageName: 'AFFILIATELIST',
                typeShow:["fastfood"]
            },
                {
                    name: 'Сотрудники',
                    path: '/Settings/UserList',
                    icon: 'group',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'USERLIST',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Точки продаж',
                    path: '/Settings/Outlets',
                    icon: 'storefront',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'OUTLETS',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Зоны доставки',
                    path: '/Settings/DeliveryZones',
                    icon: 'map',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'DELIVERYZONES',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Бонусная система',
                    path: '/Settings/BonusSystem',
                    moduleCode: 'bonus',
                    icon: 'loyalty',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'BONUSSYSTEM',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Штрихкоды (EAN-13)',
                    path: '/Settings/Barcode',
                    icon: 'qr_code_2',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'SETTINGS',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Бренды и ассортимент',
                    path: '/Settings/Brands',
                    icon: 'store',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'SETTINGS',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Телефония',
                    path: '/Settings/Telephony',
                    moduleCode: 'telephony',
                    icon: 'support_agent',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'SETTINGS',
                    typeShow:["fastfood"]
                },
                {
                    name: 'FrontPad синхронизация',
                    path: '/Settings/FrontpadSync',
                    moduleCode: 'ext_api',
                    icon: 'sync_alt',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'SETTINGS',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Сайт синхронизация',
                    path: '/Settings/SiteCatalogSync',
                    moduleCode: 'ext_api',
                    icon: 'sync_problem',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'SETTINGS',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Печать чеков',
                    path: '/PrintSettingsPage',
                    icon: 'print',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'PRINTSETTINGSPAGE',
                    typeShow:["fastfood"]
                }
            ]
        },
        {
            name: 'Маркетинг',
            moduleCode: 'marketing',
            icon: 'campaign',
            auth:authRoles.admin,
            accessPageName: 'MARKETING',
            typeShow:["fastfood"],
            children: [{
                name: 'Нарушения',
                path: '/marketing/Disturbance',
                icon: 'report_problem',
                iconText: '*',
                auth:authRoles.admin,
                accessPageName: 'DISTURBANCE',
                typeShow:["fastfood"]
            },
                {
                    name: 'Промокоды',
                    path: '/marketing/Promocode',
                    icon: 'sell',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'PROMOCODESETTINGS',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Подарки',
                    path: '/marketing/Gifts',
                    icon: 'redeem',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'PROMOCODECREATE',
                    typeShow:["fastfood"]
                }
            ]
        },
        {
            name: 'Деньги',
            iconSrc: navPayIcon,
            icon: 'account_balance_wallet',
            auth:authRoles.admin,
            accessPageName: 'MONEY',
            typeShow:["fastfood"],
            children: [{
                name: 'Касса',
                path: '/money/cashbox',
                icon: 'point_of_sale',
                iconText: '*',
                auth:authRoles.admin,
                accessPageName: 'CASHBOXX',
                typeShow:["fastfood"]
            },
                {
                    name: 'История смен',
                    path: '/money/cashbox/history',
                    icon: 'history',
                    iconText: '*',
                    auth:authRoles.admin,
                    accessPageName: 'CASHBOXX',
                    typeShow:["fastfood"]
                },
                {
                    name: 'Фискализация',
                    path: '/money/fiscal',
                    icon: 'receipt',
                    auth:authRoles.admin,
                    accessPageName: 'FISCAL_VIEW',
                    typeShow:["fastfood"]
                },
            ]
        },
        {
            name: 'Склад',
            moduleCode: 'warehouse',
            icon: 'home_work',
            auth:authRoles.test,
            accessPageName: 'WAREHOUSE',
            typeShow:["fastfood"],
            children: [
                { type: 'warehouseGroup', name: 'Работа', label: 'Работа', typeShow: ["fastfood"], children: [
                    {
                    name: 'Главная',
                    path: '/warehouse/overview',
                    icon: 'dashboard',
                    iconText: '*',
                    auth:authRoles.test,
                    accessPageName: 'WAREHOUSE_VIEW',
                    typeShow:["fastfood"]
                },{
                    name: 'Документы',
                    path: '/warehouse/documents',
                    icon: 'description',
                    iconText: '*',
                    auth:authRoles.test,
                    accessPageName: 'WAREHOUSE_DOCUMENT_VIEW',
                    typeShow:["fastfood"]
                },{
                    name: 'Инвентаризация',
                    path: '/warehouse/inventory',
                    icon: 'checklist',
                    iconText: '*',
                    auth:authRoles.test,
                    accessPageName: 'WAREHOUSE_INVENTORY_VIEW',
                    typeShow:["fastfood"]
                    }
                ]},
                { type: 'warehouseGroup', name: 'Справочники', label: 'Справочники', typeShow: ["fastfood"], children: [
                    {
                    name: 'Складские позиции',
                    path: '/warehouse/items',
                    icon: 'category',
                    iconText: '*',
                    auth:authRoles.test,
                    accessPageName: 'WAREHOUSE_CATALOG_VIEW',
                    typeShow:["fastfood"]
                },{
                    name: 'Списание по товарам',
                    path: '/warehouse/product-recipes',
                    icon: 'restaurant_menu',
                    iconText: '*',
                    auth:authRoles.test,
                    accessPageName: 'WAREHOUSE_CATALOG_VIEW',
                    typeShow:["fastfood"]
                    }
                ]},
                { type: 'warehouseGroup', name: 'Контроль', label: 'Контроль', typeShow: ["fastfood"], children: [
                    {
                    name: 'Остатки и движения',
                    path: '/warehouse/balances',
                    icon: 'view_list',
                    iconText: '*',
                    auth:authRoles.test,
                    accessPageName: 'WAREHOUSE_VIEW',
                    typeShow:["fastfood"]
                },{
                    name: 'Отчёты',
                    path: '/warehouse/reports',
                    icon: 'assessment',
                    iconText: '*',
                    auth:authRoles.test,
                    accessPageName: 'WAREHOUSE_REPORTS_VIEW',
                    typeShow:["fastfood"]
                    }
                ]},
                { type: 'warehouseGroup', name: 'Система', label: 'Система', typeShow: ["fastfood"], children: [
                    {
                    name: 'Автопозиции',
                    path: '/warehouse/automation',
                    icon: 'autorenew',
                    iconText: '*',
                    auth:authRoles.test,
                    accessPageName: 'WAREHOUSE_AUTOMATION_VIEW',
                    typeShow:["fastfood"]
                },{
                    name: 'Настройки склада',
                    path: '/warehouse/settings',
                    icon: 'settings',
                    iconText: '*',
                    auth:authRoles.test,
                    accessPageName: 'WAREHOUSE_SETTINGS_VIEW',
                    typeShow:["fastfood"]
                    }
                ]},
            ]
        }
    ];
    navigationsOld.push({ name: 'База знаний', path: '/help', icon: 'help_outline', auth: authRoles.test, typeShow: ['fastfood', 'flower_shop'] })
    return navigationsOld
}

export const navigations=SetNavTmp();
export const navTmp=SetNavTmp();

export const navigationsTmp = [];

export const navigations2 = [
    {
        name: 'Дашборд',
        path: '/dashboard/default',
        icon: 'dashboard',
    },
    {
        name: 'Альтернативная',
        path: '/dashboard/alternative',
        icon: 'analytics',
    },
    {
        name: 'Управление запасами',
        path: '/dashboard/inventory-management',
        icon: 'store',
    },
    {
        label: 'Страницы',
        type: 'label',
    },

    {
        name: 'Клиенты',
        icon: 'people',
        children: [
            {
                name: 'Customer List',
                path: '/pages/customer-list',
                iconText: 'CL',
            },
            {
                name: 'View Customer',
                path: '/pages/view-customer',
                iconText: 'VC',
            },
            {
                name: 'New Customer',
                path: '/pages/new-customer',
                iconText: 'NC',
            },
        ],
    },
    {
        name: 'Продукты',
        icon: 'shopping_cart',
        children: [
            {
                name: 'Product List',
                path: '/pages/product-list',
                iconText: 'PL',
            },
            {
                name: 'View Product',
                path: '/pages/view-product',
                iconText: 'VP',
            },
            {
                name: 'New Product',
                path: '/pages/new-product',
                iconText: 'NP',
            },
        ],
    },
    {
        name: 'Заказы',
        icon: 'folder',
        children: [
            {
                name: 'Order List',
                path: '/pages/order-list',
                iconText: 'OL',
            },
            {
                name: 'View Order',
                path: '/invoice/fdskfjdsuoiucrwevbgd',
                iconText: 'VO',
            },
        ],
    },
    {
        name: 'Справочный центр',
        icon: 'help',
        children: [
            {
                name: 'FAQ 1',
                path: '/pages/faq-1',
                iconText: 'F1',
            },
            {
                name: 'FAQ 2',
                path: '/pages/faq-2',
                iconText: 'F2',
            },
        ],
    },
    {
        name: 'Страницы тарифов',
        icon: 'money',

        children: [
            {
                name: 'Pricing 1',
                iconText: 'P1',
                path: '/others/pricing-1',
            },
            {
                name: 'Pricing 2',
                iconText: 'P2',
                path: '/others/pricing-2',
            },
            {
                name: 'Pricing 3',
                iconText: 'P3',
                path: '/others/pricing-3',
            },
            {
                name: 'Pricing 4',
                iconText: 'P4',
                path: '/others/pricing-4',
            },
        ],
    },
    {
        name: 'Список пользователей',
        icon: 'people',
        children: [
            {
                name: 'User List 1',
                path: '/pages/user-list-1',
                iconText: 'U1',
            },
            {
                name: 'User List 2',
                path: '/pages/user-list-2',
                iconText: 'U2',
            },
            {
                name: 'User List 3',
                path: '/pages/user-list-3',
                iconText: 'U3',
            },
            {
                name: 'User List 4',
                path: '/pages/user-list-4',
                iconText: 'U3',
            },
        ],
    },
    {
        name: 'Формы',
        icon: 'description',

        children: [
            {
                name: 'Форма заказа',
                path: '/forms/order-form',
                iconText: 'OF',
            },
            {
                name: 'Форма счет-фактуры',
                path: '/forms/invoice-form',
                iconText: 'IF',
            },
            {
                name: 'Property Listing Form',
                path: '/forms/property-listing-form',
                iconText: 'PF',
            },
            {
                name: 'Базовая',
                path: '/forms/basic',
                iconText: 'B',
            },
            {
                name: 'Редактор',
                path: '/forms/editor',
                iconText: 'E',
            },
            {
                name: 'Загрузка',
                path: '/forms/upload',
                iconText: 'U',
            },
            {
                name: 'Пошаговая (Wizard)',
                path: '/forms/wizard',
                iconText: 'W',
            },
        ],
    },
    {
        name: 'Matx Списки',
        icon: 'list',

        children: [
            {
                name: 'Infinite Scroll',
                path: '/infinite-scroll',
                iconText: 'I',
            },
            {
                name: 'List',
                path: '/matx-list',
                iconText: 'L',
            },
        ],
    },
    {
        name: 'Сессии/Авторизации',
        icon: 'security',
        children: [
            {
                name: 'Sign in',
                iconText: 'SI',
                path: '/session/signin',
            },
            {
                name: 'Sign up',
                iconText: 'SU',
                path: '/session/signup',
            },
            {
                name: 'Forgot Password',
                iconText: 'FP',
                path: '/session/forgot-password',
            },
            {
                name: 'Error',
                iconText: '404',
                path: '/session/404',
            },
        ],
    },
    {
        name: 'Левое меню (сайдбар)',
        path: '/page-layouts/Left-sidebar-card',
        icon: 'vertical_split',
    },
    {
        name: 'Профиль пользователя',
        path: '/page-layouts/user-profile',
        icon: 'person',
    },

    {
        label: 'Apps',
        type: 'label',
    },
    {
        name: 'Ecommerce',
        icon: 'shopping_basket',

        children: [
            {
                name: 'Магазин',
                path: '/ecommerce/shop',
                iconText: 'S',
            },
            {
                name: 'Корзина',
                path: '/ecommerce/cart',
                iconText: 'C',
            },
            {
                name: 'Проверка',
                path: '/ecommerce/checkout',
                iconText: 'CO',
            },
        ],
    },
    {
        name: 'Scrum Board',
        icon: 'group_work',
        path: '/scrum-board/c5d7498bbcb84d81fc7454448871ac6a6e',
    },
    {
        name: 'Конструктор счетфактур',
        icon: 'receipt',
        path: '/invoice/list',
    },
    {
        name: 'Календарь',
        icon: 'date_range',
        path: '/calendar',
    },
    {
        name: 'Чат',
        icon: 'chat',
        path: '/chat',
    },
    {
        name: 'Почта',
        icon: 'inbox',
        path: '/inbox',
    },
    {
        name: 'Задачи',
        icon: 'center_focus_strong',
        path: '/todo/list',
    },
    {
        label: 'Таблицы',
        type: 'label',
    },
    {
        name: 'CRUD Таблицы',
        icon: 'format_list_bulleted',
        path: '/crud-table',
    },
    {
        name: 'Таблица данных',
        icon: 'table_view',

        children: [
            {
                name: 'Simple Mui Table',
                path: '/data-table/simple-mui-table',
                iconText: 'T1',
            },
            {
                name: 'Expandable Mui Table',
                path: '/data-table/expandable-mui-table',
                iconText: 'T2',
            },
        ],
    },
    {
        label: 'Компоненты',
        type: 'label',
    },
    {
        name: 'Компоненты',
        icon: 'favorite',
        badge: { value: '30+', color: 'secondary' },
        children: [
            {
                name: 'Автозаполнение',
                path: '/material/autocomplete',
                iconText: 'A',
            },
            {
                name: 'Кнопки',
                path: '/material/buttons',
                iconText: 'B',
            },
            {
                name: 'Чекбоксы',
                path: '/material/checkbox',
                iconText: 'C',
            },
            {
                name: 'Диалоговые окна',
                path: '/material/dialog',
                iconText: 'D',
            },
            {
                name: 'Drag and Drop',
                iconText: 'D',
                path: '/others/drag-and-drop',
            },
            {
                name: 'Расширенная панель',
                path: '/material/expansion-panel',
                iconText: 'E',
            },
            {
                name: 'Форма',
                path: '/material/form',
                iconText: 'F',
            },
            {
                name: 'Иконки',
                path: '/material/icons',
                iconText: 'I',
            },
            {
                name: 'Меню',
                path: '/material/menu',
                iconText: 'M',
            },
            {
                name: 'Прогресс бар',
                path: '/material/progress',
                iconText: 'P',
            },
            {
                name: 'Радио чекбокс',
                path: '/material/radio',
                iconText: 'R',
            },
            {
                name: 'Переключатели',
                path: '/material/switch',
                iconText: 'S',
            },
            {
                name: 'Слайдеры',
                path: '/material/slider',
                iconText: 'S',
            },
            {
                name: 'СнекБар (Всплывашки)',
                path: '/material/snackbar',
                iconText: 'S',
            },
            {
                name: 'Таблицы',
                path: '/material/table',
                iconText: 'T',
            },
        ],
    },
    {
        name: 'Утилиты',
        icon: 'format_list_bulleted',
        children: [
            {
                name: 'Цвета',
                path: '/utilities/color',
                iconText: 'C',
                auth: authRoles.admin,
            },
            {
                name: 'Отступы',
                path: '/utilities/spacing',
                iconText: 'S',
                auth: authRoles.admin,
            },
            {
                name: 'Типография',
                path: '/utilities/typography',
                iconText: 'T',
            },
            {
                name: 'Отображение',
                path: '/utilities/display',
                iconText: 'D',
            },
            {
                name: 'Позиционирование',
                path: '/utilities/position',
                iconText: 'P',
            },
            {
                name: 'Тени',
                path: '/utilities/shadow',
                iconText: 'S',
            },
        ],
    },
    {
        name: 'Карта',
        icon: 'add_location',
        path: '/map',
    },
    {
        label: 'Графики',
        type: 'label',
    },
    {
        name: 'Графики',
        icon: 'trending_up',

        children: [
            {
                name: 'Echarts',
                path: '/charts/echarts',
                iconText: 'E',
            },
            {
              name: "Recharts",
              path: "/charts/recharts",
              iconText: "R",
            },
            {
                name: 'React Vis',
                path: '/charts/react-vis',
                iconText: 'R',
            },
            {
                name: 'Victory Chart',
                path: '/charts/victory-charts',
                iconText: 'V',
            },
        ],
    },
    {
        name: 'Документация',
        icon: 'launch',
        type: 'extLink',
        path: 'http://demos.ui-lib.com/matx-react-doc/',
    },
]
